<template>
  <div>
    <section class="champ-cinema pt-4 pb-4" id="champ-cinema">
      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="mb-4">
            <h4 class="section-title d-inline-block">{{ portalConfig.text.topPickVideos }}</h4>
          </b-col>
          <b-col cols="12" md="6">
            <b-link to="/ChampionsCinema" class="champ-cinema__link d-none d-md-block">View More <font-awesome-icon :icon="['fas', 'caret-right']" /></b-link>
          </b-col>
        </b-row>
        <GetData :endpoint='"articles/" + portalConfig.portalName + "/videos/top-picks" + count + page' :key="componentKeyTPV">
          <FrogVideoCard
            :cols="12" :md="6" :lg="3"
            :cardType="portalConfig.themeLayout.id"
            slot-scope="{ response: videos }"
            :result="videos.results"
            :portalName="portalConfig.portalName"
            :pagination="true"
            :prevData="videos.previousCursor"
            :nextData="videos.nextCursor"
            @nextVideoPage="nextVideoPage(videos.nextCursor)"
            @previousVideoPage="prevVideoPage(videos.previousCursor)"
          />
        </GetData>
      </b-container>
    </section>
  </div>
</template>

<script>
import GetData from '@/services/GetData'
import FrogVideoCard from '@/components/FrogVideoCard'
import { mapGetters } from 'vuex'

const breakpoints = {
  sm: 540,
  md: 720,
  lg: 960
}

export default {
  name: 'SectionChampCinema',
  props: {
    result: Array,
    breakpoints: Object
  },
  components: {
    GetData,
    FrogVideoCard
  },
  data: () => {
    return {
      componentKeyTPV: 0,
      page: '',
      count: ''
    }
  },
  computed: {
    ...mapGetters({
      portalConfig: 'getPortalConfig'
    })
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
    this.resizeHandler()
  },
  methods: {
    forceRerender () {
      this.componentKeyTPV += 1
    },
    nextVideoPage (next) {
      this.componentKeyTPV++
      this.page = '&next=' + next
    },
    prevVideoPage (prev) {
      this.componentKeyTPV++
      this.page = '&previous=' + prev
    },
    resizeHandler (e) {
      const clientWidth = window.innerWidth
      if (clientWidth < breakpoints.md) {
        this.count = '?count=1'
      } else {
        this.count = '?count=4'
      }
    }
  }
}
</script>
